// Заглушка первой загрузки (README «Состояния»; Skeleton/README.md): пока сервис узнаёт, кто
// вошёл (/api/auth/me), видно не пустой холст, а каркас той же формы — меню на холсте, лист со
// шапкой и страница со скелетом заголовка и строк. Только при настоящем ожидании: маршрутизатор
// показывает её после 0,3 с (pendingMs), экран не прыгает — форма та же, что у каркаса.
import { Skeleton, SkeletonBar, SkeletonRow } from '@kp/ui';

/** Скелет страницы: заголовок, строка пояснения и строки списка. */
export function PageSkeleton() {
  return (
    <Skeleton delay={0} className="kp-page-skeleton">
      <SkeletonBar width="32%" height={22} />
      <SkeletonBar width="48%" height={12} />
      <div className="kp-page-skeleton-rows">
        {['46%', '62%', '38%', '54%', '42%', '58%'].map((width) => (
          <SkeletonRow key={width} width={width} />
        ))}
      </div>
    </Skeleton>
  );
}

/** Страница маршрута, который ещё загружается (defaultPendingComponent), — внутри каркаса. */
export function PagePending() {
  return (
    <main id="main" tabIndex={-1} className="kp-page">
      <PageSkeleton />
    </main>
  );
}

/** Каркас целиком: меню, шапка листа и скелет страницы (pendingComponent маршрута каркаса). */
export function ShellSkeleton() {
  return (
    <div className="kp-app">
      <aside className="kp-sidebar kp-sk-side" aria-hidden="true">
        <div className="kp-sidebar-in">
          <SkeletonBar width="70%" height={20} />
          <div className="kp-sk-nav">
            {['56%', '72%', '64%', '68%', '60%'].map((width) => (
              <SkeletonBar key={width} width={width} height={12} />
            ))}
          </div>
          <div className="kp-sidebar-foot">
            <SkeletonBar width="80%" height={36} />
          </div>
        </div>
      </aside>
      <div className="kp-sheet">
        <div className="kp-topbar" aria-hidden="true">
          <SkeletonBar width={120} height={12} />
          <span className="sp" />
          <SkeletonBar width={200} height={24} className="kp-hide-phone" />
        </div>
        <PagePending />
      </div>
    </div>
  );
}
